import '../sass/homepage-hero.scss';

(() => {
    const $blocks = document.querySelectorAll('.block.homepage-hero');

    if (!$blocks) return;

    $blocks.forEach($block => {
        const $scrollBtn = $block.querySelector('.homepage-hero__scroll-btn');

        const initScrollBtn = () => {
            if (!$scrollBtn) return;

            $scrollBtn.addEventListener('click', e => {
                e.preventDefault();

                window.scrollTo({
                    top: $block.offsetTop + $block.offsetHeight,
                    behavior: 'smooth'
                });
            });
        };

        initScrollBtn();
    });
})();
